module.exports = __webpack_public_path__ + "img/logo.0955f217.svg";